import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BrandAssetContent } from "../types";
import { DEFAULT_LOGO_HEIGHT, PARAM_LOGO_HEIGHT_KEY } from "../constants";

interface ParametersPanelProps {
  parameters: BrandAssetContent["parameters"];
  onLogoHeightChange: (height: number) => void;
  onParameterChange: (key: string, value: unknown) => void;
}

const ParametersPanel: React.FC<ParametersPanelProps> = ({
  parameters,
  onLogoHeightChange,
  onParameterChange,
}) => {
  const { t } = useTranslation(["corporate-brand-asset"]);
  const extraKeys = Object.keys(parameters).filter(
    (k) => k !== PARAM_LOGO_HEIGHT_KEY,
  );

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            type="number"
            size="small"
            fullWidth
            label={t("parameters.logoHeight")}
            value={parameters[PARAM_LOGO_HEIGHT_KEY] ?? DEFAULT_LOGO_HEIGHT}
            onChange={(e) =>
              onLogoHeightChange(Number(e.target.value) || DEFAULT_LOGO_HEIGHT)
            }
            inputProps={{ min: 1 }}
          />
        </Grid>
        {extraKeys.map((key) => (
          <Grid item xs={12} sm={6} key={key}>
            <TextField
              size="small"
              fullWidth
              label={key}
              value={String(parameters[key] ?? "")}
              onChange={(e) => onParameterChange(key, e.target.value)}
            />
          </Grid>
        ))}
      </Grid>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 1, display: "block" }}
      >
        {t("parameters.hint")}
      </Typography>
    </Box>
  );
};

export default ParametersPanel;
